// extracted by mini-css-extract-plugin
export var active = "direction-item-module--active--WhTzk";
export var tag = "direction-item-module--tag--G+6I6";
export var tagLink = "direction-item-module--tag-link--cCA9i";